export const menuTypeValue = {
  MENU: 'MENU',
  BUTTON: 'BUTTON',
};

export const menuTypes = [
  { label: '菜单', value: menuTypeValue.MENU },
  { label: '按钮', value: menuTypeValue.BUTTON },
];
